<template>
  <div class="note-main">
    <div class="note-header">
      <div class="note-tags" v-for="item in notetags" :key="item">
        {{ "#" + item }}
      </div>
    </div>
    <div class="note-container">
      <ul class="note-list waterfall-width-column">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <li
            class="note-item image-box"
            v-for="item in noteList"
            :key="item.r.id"
          >
            <noteitem :currentItem="item"></noteitem>
          </li>
        </van-list>
      </ul>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Grid, GridItem, Lazyload, List } from "vant";
import url from "@/url/url.js";
import noteitem from "./noteitem";

Vue.use(Grid);
Vue.use(GridItem);
Vue.use(Lazyload);
Vue.use(List);
export default {
  data() {
    return {
      notetags: [
        "健康打卡食记录",
        "新疆必吃美食",
        "把春天搬上桌",
        "地方特色美食",
        "营养健康汤",
        "辜负好春光",
      ],
      noteList: [],
      requestlist: ["早餐", "午餐", "晚餐"],
      loading: false,
      finished: false,
      index: 0,
    };
  },
  components: {
    noteitem: noteitem,
  },
  methods: {
    onLoad() {
      this.$http
        .get(url.recipeUrl, {
          params: {
            keyword: this.requestlist[this.index],
          },
        })
        .then((res) => {
          this.index++;
          console.log(res);
          if (res.result) {
            let resArr = res.result.list;
            resArr.forEach((item) => {
              if (typeof item === "object" && item.r) {
                this.noteList.push(item);
              }
            });
          }
          this.loading = false;

          if (this.index == this.requestlist.length) {
            this.finished = true;
          }
        });
    },
  },
};
</script>
<style lang="scss">
.waterfall-width-column {
  column-count: 2;
  column-gap: 6px;
  .image-box {
    img {
      display: block;
      width: 100%;
    }
  }
}
.note-header {
  margin: 5px 0px;
  width: 100%;
  overflow: hidden;
  ::after {
    content: "";
    display: block;
    clear: both;
    opacity: 0;
    height: 0;
  }
  .note-tags {
    float: left;
    font-size: 14px;
    line-height: 32px;

    background: rgba(147, 207, 240, 0.2);
    padding: 0px 10px;
    color: rgb(46, 136, 163);
    margin: 5px 3px;
    border-radius: 10px;
  }
  // 实现一个瀑布流
  //用嘴原生的方法去写
  //高度数组的方法去写
  //但是有个坑 我们不知道图片的高度
  //我们可以用嗯就是图片加载完之后再去获取高度
  //那样就不好用
}
</style>
